import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import pulseServices from "app/services/pulse-services";
import { pct, timeAgo } from "./pulseFormat";

// "12 (antes 18)": la semana contra la anterior, que es lo que dice si un cliente se enfria.
const Trend = ({ now, before }) => {
    const down = before > 0 && now < before * 0.7;
    return (
        <>
            {now}
            <Typography component="span" variant="caption" color={down ? "error.main" : "text.secondary"}>
                {" "}({down ? "▼ " : ""}antes {before})
            </Typography>
        </>
    );
};

const HealthTab = () => {
    const [rows, setRows] = useState(null);

    useEffect(() => {
        pulseServices.health().then(setRows).catch(() => setRows([]));
    }, []);

    if (!rows) return <Stack alignItems="center" sx={{ py: 8 }}><CircularProgress color="warning" /></Stack>;

    return (
        <Card variant="outlined">
            <CardContent>
                <Typography variant="h6">Salud por cliente</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    Últimos 7 días contra los 7 anteriores. Los avisos marcan a quién llamar.
                </Typography>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Cliente</TableCell>
                                <TableCell>Avisos</TableCell>
                                <TableCell align="right">Usuarios</TableCell>
                                <TableCell align="right">Días activos</TableCell>
                                <TableCell align="right">App / Web</TableCell>
                                <TableCell align="right">Pedidos</TableCell>
                                <TableCell align="right">Viajes</TableCell>
                                <TableCell align="right">% optimizados</TableCell>
                                <TableCell align="right">Entregas</TableCell>
                                <TableCell align="right">% con firma</TableCell>
                                <TableCell align="right">% no entregadas</TableCell>
                                <TableCell align="right">Errores</TableCell>
                                <TableCell>Versiones de la app</TableCell>
                                <TableCell>Último uso</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((r) => (
                                <TableRow key={r.company_id} hover>
                                    <TableCell><b>{r.name}</b></TableCell>
                                    <TableCell sx={{ minWidth: 220 }}>
                                        {r.alerts.length === 0
                                            ? <Chip size="small" color="success" variant="outlined" label="Sin avisos" />
                                            : r.alerts.map((a) => <Chip key={a} size="small" color="warning" variant="outlined" label={a} sx={{ m: 0.25, height: "auto", "& .MuiChip-label": { whiteSpace: "normal", py: 0.25 } }} />)}
                                    </TableCell>
                                    <TableCell align="right"><Trend now={r.users_7d} before={r.users_prev_7d} /></TableCell>
                                    <TableCell align="right">{r.active_days_7d}/7</TableCell>
                                    <TableCell align="right">{r.app_users_7d} / {r.web_users_7d}</TableCell>
                                    <TableCell align="right"><Trend now={r.orders_7d} before={r.orders_prev_7d} /></TableCell>
                                    <TableCell align="right">{r.trips_7d}</TableCell>
                                    <TableCell align="right">{pct(r.optimized_pct)}</TableCell>
                                    <TableCell align="right">{r.deliveries_finished_7d}/{r.deliveries_7d}</TableCell>
                                    <TableCell align="right">{pct(r.signed_pct)}</TableCell>
                                    <TableCell align="right">{pct(r.cancelled_pct)}</TableCell>
                                    <TableCell align="right">
                                        {r.errors_7d}
                                        {r.rejected_7d > 0 && <Typography component="span" variant="caption" color="text.secondary"> +{r.rejected_7d} rech.</Typography>}
                                    </TableCell>
                                    <TableCell>
                                        {r.app_versions.length === 0 ? "-" : r.app_versions.map((v) => (
                                            <Chip key={v.version} size="small" variant="outlined" sx={{ m: 0.25, height: 20, fontSize: 11 }} label={`${v.version} · ${v.users}`} />
                                        ))}
                                    </TableCell>
                                    <TableCell>{timeAgo(r.last_seen_at)}</TableCell>
                                </TableRow>
                            ))}
                            {rows.length === 0 && (
                                <TableRow><TableCell colSpan={14}><Typography color="text.secondary">Sin datos todavía.</Typography></TableCell></TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                    Usuarios, días activos y versiones se miden desde que se activó el Pulso; pedidos, viajes y entregas traen toda la historia.
                </Typography>
            </CardContent>
        </Card>
    );
};

export default HealthTab;
